export const ALL_LANGUAGE_VARIATIONS = 'all';